import mockAxios, { AxiosResponse } from 'axios';
import { IWorkflowServiceMock } from './workflow.mock.types';

export const mockWorkflowService = (): IWorkflowServiceMock => ({
  fetchWorkflows: jest.fn(),
  fetchWorkflow: jest.fn(),
  createWorkflow: jest.fn(),
  updateWorkflow: jest.fn(),
  deleteWorkflow: jest.fn(),

  setWorkflowState: jest.fn(),

  /* #### State #### */
  fetchWorkflowStates: jest.fn(),
  fetchWorkflowState: jest.fn(),
  createWorkflowState: jest.fn(),
  updateWorkflowState: jest.fn(),
  deleteWorkflowState: jest.fn(),

  /* #### Transition #### */
  fetchWorkflowTransitions: jest.fn(),
  fetchWorkflowTransition: jest.fn(),
  createWorkflowTransition: jest.fn(),
  updateWorkflowTransition: jest.fn(),
  deleteWorkflowTransition: jest.fn(),

  /* #### Workflow State Threshold Group #### */
  fetchWorkflowStateThresholdGroups: jest.fn(),
  fetchWorkflowStateThresholdGroup: jest.fn(),
  createWorkflowStateThresholdGroup: jest.fn(),
  updateWorkflowStateThresholdGroup: jest.fn(),
  deleteWorkflowStateThresholdGroup: jest.fn(),

  /* #### State Threshold #### */
  fetchWorkflowStateThresholds: jest.fn(),
  fetchWorkflowStateThreshold: jest.fn(),
  createWorkflowStateThreshold: jest.fn(),
  updateWorkflowStateThreshold: jest.fn(),
  deleteWorkflowStateThreshold: jest.fn(),

  /* #### Transition Actions #### */
  fetchWorkflowTransitionActions: jest.fn(),
  fetchWorkflowTransitionAction: jest.fn(),
  createWorkflowTransitionAction: jest.fn(),
  updateWorkflowTransitionAction: jest.fn(),
  deleteWorkflowTransitionAction: jest.fn(),

  fetchWorkflowTransitionActionsEmailRecipients: jest.fn()
});
export function mockWorkflowAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
